import Vue from 'vue';
import $device from 'mobile-device-detect';

Vue.prototype.$device = $device;
